module.exports = __webpack_public_path__ + "img/unchecked-favor_l.de34f4c7.svg";